import { FOOTER } from '../../consts';
import { replaceStringWithYear } from '../../utilities';
import { ErrorBoundary } from '../ErrorBoundary';
import { Loader } from '../Loader';
import { Logo } from '../Logo';
import { Navigation } from '../Navigation';
import '@alto-avios/alto-tokens/web/avios/fonts.css';
import { useVersioningDataProps } from '../../hooks/useVersioningDataProps';
import { useOptionalContent, FooterContent } from '../services/content';

import styles from './Footer.module.scss';

export const Footer = () => {
  const { data, isFetching } = useOptionalContent(FooterContent);
  const altoButtonHeight = 48;
  const versioningDataProps = useVersioningDataProps();

  return (
    <ErrorBoundary>
      <footer className={styles.footer} {...versioningDataProps}>
        <div className={styles.footerContainer}>
          <div className={styles.navContainer}>
            <div className={styles.top}>
              {isFetching || !data ? <Loader height={altoButtonHeight} width={140} /> : <Logo imageData={data.logo} variant={FOOTER} />}
              <div className={styles.footerNavigation}>
                {isFetching ? (
                  <ul className={styles.ul}>
                    {data?.links.map((link) => (
                      <li key={link.label}>
                        <Loader height={altoButtonHeight} width={175} />
                      </li>
                    ))}
                  </ul>
                ) : (
                  <Navigation variant={FOOTER} />
                )}
              </div>
            </div>
          </div>
          <div className={styles.divider}></div>
          <p className={styles.copyright}>{data && replaceStringWithYear(data.copyright)}</p>
        </div>
      </footer>
    </ErrorBoundary>
  );
};
